// src/config/routes.ts
import Home from '../pages/index';
import Details from '../pages/details';

export interface RouteConfig {
  path: string;
  name: string;
  icon?: string;
  component: React.ComponentType<any>;
  children?: RouteConfig[];
}

export const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'DPSA Reprocessing Tool',
    icon: 'bi-house',
    component: Home
    // children: [
    //   {
    //     path: '/home',
    //     name: 'RequestList',
    //     component: Home
    //   }
    // ]
  },
  {
    path: '/details/:appname',
    name: 'Details',
    icon: 'bi-house',
    component: Details,
    
  },

];

export default routes; 